import React from 'react';
import { PlaceTypeEnumType } from '@wix/ambassador-seating-v1-seating-plan/types';
import { AccessibilitySmall, CouponSmall, StatusWarningSmall, UsersSmall, WheelchairSmall, } from '@wix/wix-ui-icons-common';
export const SeatTypeImage = ({ type, x, y, ...rest }) => {
    switch (type) {
        case PlaceTypeEnumType.WHEELCHAIR:
            return React.createElement(WheelchairSmall, { ...rest, x: x, y: y });
        case PlaceTypeEnumType.ACCESSIBLE:
            return React.createElement(AccessibilitySmall, { ...rest, x: x, y: y + 0.5 });
        case PlaceTypeEnumType.COMPANION:
            return React.createElement(UsersSmall, { ...rest, x: x - 0.8, y: y + 0.8 });
        case PlaceTypeEnumType.OBSTRUCTED:
            return React.createElement(StatusWarningSmall, { ...rest, x: x, y: y });
        case PlaceTypeEnumType.DISCOUNT:
            return React.createElement(CouponSmall, { ...rest, x: x, y: y + 0.7 });
        default:
            return null;
    }
};
//# sourceMappingURL=seat-type-image.js.map